import { AuthState, useAuth } from '@furality/frontend-stack';

/**
 * Hook to determine whether the page is loading or not
 *
 * Used to "break" SSR in some places to prevent hydration issues
 */
const useLoading = () => useAuth().state === AuthState.Loading;

export default useLoading;
